import { AttendanceFilterOptionValue, FormatFilterOptionValue } from '@studyportals/search-filters';

class StudyCardDefinitions {
	public readonly format: Map<string, string> = new Map<string, string>([
		[FormatFilterOptionValue.FULL_TIME, 'Full-time'],
		[FormatFilterOptionValue.PART_TIME, 'Part-time']
	]);

	public readonly attendance: Map<string, string> = new Map<string, string>([
		[AttendanceFilterOptionValue.BLENDED, 'Blended'],
		[AttendanceFilterOptionValue.FACE_2_FACE, 'On Campus'],
		[AttendanceFilterOptionValue.ONLINE, 'Online']
	]);
}

export default new StudyCardDefinitions();
